// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareVehicleSearchFields() {
    val props: Array<SerializableProperty<VehicleSearch, *>> = arrayOf(VehicleSearch__id, VehicleSearch_name)
    VehicleSearch.serializer().properties { props }
}
val <K> DataClassPath<K, VehicleSearch>._id: DataClassPath<K, UUID> get() = this[VehicleSearch__id]
val <K> DataClassPath<K, VehicleSearch>.name: DataClassPath<K, String> get() = this[VehicleSearch_name]
inline val VehicleSearch.Companion.path: DataClassPath<VehicleSearch, VehicleSearch> get() = path<VehicleSearch>()


object VehicleSearch__id: SerializableProperty<VehicleSearch, UUID> {
    override val name: String by lazy { VehicleSearch.serializer().descriptor.getElementName(0) }
    override fun get(receiver: VehicleSearch): UUID = receiver._id
    override fun setCopy(receiver: VehicleSearch, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (VehicleSearch.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { VehicleSearch.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = uuid()
    override val defaultCode: String? = "uuid()" 
}
object VehicleSearch_name: SerializableProperty<VehicleSearch, String> {
    override val name: String by lazy { VehicleSearch.serializer().descriptor.getElementName(1) }
    override fun get(receiver: VehicleSearch): String = receiver.name
    override fun setCopy(receiver: VehicleSearch, value: String) = receiver.copy(name = value)
    override val serializer: KSerializer<String> by lazy { (VehicleSearch.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { VehicleSearch.serializer().descriptor.getElementAnnotations(1) }
}
